import { BaseConfigurationDrawer } from '@terminal/components/base-configuration-drawer/BaseConfigurationDrawer';
import { queryValues } from '@terminal/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useTranslation } from 'react-i18next';

import { PeriodChanger } from '../period-changer/PeriodChanger';
import styles from './WhatsNewSettingsDrawer.module.scss';

export const WhatsNewSettingsDrawer = () => {
  const { t } = useTranslation(['whatsNew', 'stream']);

  const headerSection = (
    <div className={styles.headerSection}>
      <h3 className={styles.drawerTitle}>{t('whatsNew:drawer.title')}</h3>
      <div className={styles.periodWrapper}>
        <p className={styles.description}>
          {t('whatsNew:drawer.periodDescription')}
        </p>
        <PeriodChanger />
      </div>
    </div>
  );

  return (
    <BaseConfigurationDrawer
      trackingSource={POSTHOG_TRACKING_SOURCES.WHATS_NEW_WIDGET}
      activeDrawer={queryValues.whatsNewSettingsDrawer}
      headerSection={headerSection}
      testId="whats-new-settings-drawer"
    />
  );
};
